/* Accord Technologie — sélecteur de garantie 2 étages (durée × service)
   Amélioration progressive : si les variantes ne forment pas une matrice
   lisible, le menu déroulant natif reste affiché tel quel. */
(function () {
  'use strict';

  function parseVariant(v) {
    var m = v.t.match(/(\d+)\s*mois/);
    if (!m) return null;
    var d = parseInt(m[1], 10);
    var t = v.t.toLowerCase();
    var s;
    if (t.indexOf('sur site') !== -1) s = 'site';
    else if (t.indexOf('express') !== -1) s = 'express';
    else if (t.indexOf('atelier') !== -1) s = 'atelier';
    else s = 'std';
    return { id: v.id, title: v.t, price: v.p, ok: v.a, d: d, s: s };
  }

  var SVC_LABELS = {
    atelier: ['Enlèvement et retour atelier', 'UPS récupère, Wortmann répare, retour chez vous'],
    site: ['Intervention sur site sous 24 h', 'Un technicien se déplace dans vos locaux'],
    express: ['Enlèvement + réparation express', 'Prise en charge prioritaire en atelier'],
    std: ['Extension de garantie constructeur', 'Gérée par Wortmann AG']
  };
  var SVC_ORDER = ['atelier', 'site', 'express', 'std'];

  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function init(root) {
    var sectionId = root.getAttribute('data-section');
    var dataEl = document.querySelector('script[data-at-war-data="' + sectionId + '"]');
    var nativeWrap = root.closest('.product-accord__options');
    if (!dataEl || !nativeWrap) return;

    var raw;
    try { raw = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!raw || raw.length < 2 || raw.length > 24) return;

    var vs = [];
    for (var i = 0; i < raw.length; i++) {
      var p = parseVariant(raw[i]);
      if (!p) return; // une variante hors schéma → on garde le natif
      vs.push(p);
    }

    var durs = [], svcs = [], matrix = {};
    vs.forEach(function (v) {
      if (durs.indexOf(v.d) === -1) durs.push(v.d);
      if (svcs.indexOf(v.s) === -1) svcs.push(v.s);
      matrix[v.s] = matrix[v.s] || {};
      if (matrix[v.s][v.d]) return; // doublon → schéma invalide
      matrix[v.s][v.d] = v;
    });
    durs.sort(function (a, b) { return a - b; });
    svcs.sort(function (a, b) { return SVC_ORDER.indexOf(a) - SVC_ORDER.indexOf(b); });
    if (durs.length < 2 || durs.length > 6 || svcs.length > 3) return;

    var base = Math.min.apply(null, vs.map(function (v) { return v.price; }));
    var getSelect = function () { return nativeWrap.querySelector('select'); };
    var select = getSelect();
    if (!select) return;

    // état initial depuis la variante sélectionnée
    var selId = parseInt(root.getAttribute('data-selected'), 10);
    var cur = vs.filter(function (v) { return v.id === selId; })[0] || vs.filter(function (v) { return v.ok; })[0] || vs[0];
    var d = cur.d, s = cur.s;

    // construire l'UI
    var seg = root.querySelector('[data-at-war-seg]');
    var rows = root.querySelector('[data-at-war-rows]');
    seg.innerHTML = durs.map(function (dd) {
      return '<button type="button" data-d="' + dd + '">' + dd + ' mois</button>';
    }).join('');
    rows.innerHTML = svcs.map(function (ss) {
      var L = SVC_LABELS[ss] || SVC_LABELS.std;
      return '<div class="at-war__row" data-s="' + ss + '" role="button" tabindex="0">' +
        '<span class="at-war__rad"></span>' +
        '<span class="at-war__tx"><b>' + L[0] + '</b><span>' + L[1] + '</span></span>' +
        '<span class="at-war__pr"></span><span class="at-war__soldout" hidden>Épuisé</span></div>';
    }).join('');
    if (svcs.length === 1) rows.previousElementSibling.hidden = true;

    function render() {
      seg.querySelectorAll('button').forEach(function (b) {
        b.classList.toggle('on', parseInt(b.dataset.d, 10) === d);
      });
      rows.querySelectorAll('.at-war__row').forEach(function (r) {
        var v = matrix[r.dataset.s][d];
        var pr = r.querySelector('.at-war__pr');
        var tag = r.querySelector('.at-war__soldout');
        if (!v) {
          pr.textContent = '\u2014';
          pr.classList.remove('at-war__pr--free');
          r.classList.add('off');
          tag.textContent = 'Non propos\u00e9';
          tag.hidden = false;
          return;
        }
        var delta = v.price - base;
        pr.textContent = delta <= 0 ? 'incluse' : '+ ' + fmt(delta);
        pr.classList.toggle('at-war__pr--free', delta <= 0);
        r.classList.toggle('off', !v.ok);
        tag.textContent = '\u00c9puis\u00e9';
        tag.hidden = v.ok;
      });
      if (!matrix[s][d] || !matrix[s][d].ok) {
        var alt = svcs.filter(function (ss) { return matrix[ss][d] && matrix[ss][d].ok; })[0] ||
                  svcs.filter(function (ss) { return matrix[ss][d]; })[0];
        if (alt) s = alt;
      }
      rows.querySelectorAll('.at-war__row').forEach(function (r) {
        r.classList.toggle('on', r.dataset.s === s);
      });
      var note = root.querySelector('[data-at-war-note]');
      if (note) note.hidden = !(s === 'express' && d > 36);
      // piloter le select natif (résolu à chaque fois : Dawn le remplace après morph)
      var v = matrix[s][d];
      if (!v) return;
      var sel = getSelect();
      if (sel && sel.value !== v.title) {
        sel.value = v.title;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    seg.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-d]');
      if (b) { d = parseInt(b.dataset.d, 10); render(); }
    });
    function pick(e) {
      var r = e.target.closest('.at-war__row');
      if (r && !r.classList.contains('off')) { s = r.dataset.s; render(); }
    }
    rows.addEventListener('click', pick);
    rows.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { pick(e); e.preventDefault(); }
    });

    nativeWrap.classList.add('at-war-active');
    root.hidden = false;
    render();
  }

  function boot() {
    document.querySelectorAll('[data-at-war]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
